import React, { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSafeNavigate } from "../../components/unloadBlocker";

interface HeaderLinkProps {
    icon?: ReactNode;
    name: string;
    link: string;
    setActiveName?: (v: string) => void;
    className?: string;
    navigate?: boolean;

}

export default function HeaderLink(props: HeaderLinkProps) {

    const location = useLocation();
    const navigate = useSafeNavigate(useNavigate());

    useEffect(() => {
        if(location.pathname.toLowerCase().startsWith("/" + props.link.toLowerCase()) && props.setActiveName) {
            props.setActiveName(props.name);
        }
    })

    return <li onClick={() => {
        var link = "/" + props.link;
        if(!props.navigate) {

        window.open(link, "_self");
        }else {
            navigate(link);
        }
    }} className={(location.pathname.toLowerCase().startsWith("/" + props.link.toLowerCase()) ? "active" : "") + (props.className ? " " + props.className : "")}>
        {props.icon}
        <h3>{props.name}</h3>
    </li>
}